var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOptionCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fa6-solid:check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9142 9.41421C20.6953 8.63317 20.6953 7.36683 19.9142 6.58579C19.1332 5.80474 17.8668 5.80474 17.0858 6.58579L10.5 13.1716L7.91421 10.5858C7.13317 9.80474 5.86683 9.80474 5.08579 10.5858C4.30474 11.3668 4.30474 12.6332 5.08579 13.4142L9.08579 17.4142C9.86683 18.1953 11.1332 18.1953 11.9142 17.4142L19.9142 9.41421Z",
    fill: "#0E6AF4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionCheck);
export default __webpack_public_path__ + "static/media/option_check.d05b89b35766ec86adab0f108a3de0a8.svg";
export { ForwardRef as ReactComponent };